<template>
  <div>
    <header class="voucher-header" v-if="deviceType === 'ssfamilyhub'">
      <h1 class="a11y-hidden">웨이브</h1>
      <div class="header-top">
        <h2 class="hd-title">wavve 상품구매</h2>

        <button class="btn-back" type="button" @click.prevent="close">
          <span class="a11y-hidden">뒤로 가기</span>
          <span class="icon-back"><BackButton/> </span>
        </button>

        <button class="btn-close" type="button" @click.prevent="close">
          <span class="a11y-hidden">나가기</span>
          <span class="icon-close"><CloseButton/></span>
        </button>
      </div>
    </header>
    <portal-target name="agreement-popup"></portal-target>
    <div class="wrap" v-if="!isLoading && !isEmptyList">
      {{dataList.length}}
      <div class="voucher-wrap">
      <voucher-banner banner-id="voucher_recommend"></voucher-banner>
      <!-- 이용권 리스트 출력 -->
      <template v-if="dataList">
        <popup-all-product-category-new v-for="(data, index) in dataList"
                                        :key="index"
                                        :category="data"
                                        :voucherData="[]"
                                        :category-index="index"
                                        :user-line="userLine"
                                        :menu-name="type"
                                        :set-number-commas="setNumberCommas"
                                        :is-playy="isplayy"
                                        :current-index="currentIndex"
        />
      </template>
      <voucher-total-box v-if="!isLoading" :product-type="currentProductType" :purchase="purchase" :current-voucher-info="currentVoucherInfo"/>
        <bottom-guide-ios id="bottomGuide" v-if="device === 'ios'"></bottom-guide-ios>
        <popup-voucher-guide v-else/>
      </div>
    </div>
    <div v-else-if="!isLoading && isEmptyList">
      <template>
        <div class="ticket-wrap">
          <my-pooq-empty-list info-text="구매 가능한 상품이 없어요."/>
          <div class="voucher-wrap">
            <popup-voucher-guide />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import CloseButton from '@/assets/svg/common/ic_gnb_close_w.svg'
import VoucherBanner from '@/components/lnb/voucher/VoucherBanner'
import PopupAllProductCategoryNew from '@/components/voucher/PopupAllProductCategoryNew'
import { BottomTabService, VoucherService } from '@/common/api/api.service'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import VoucherTotalBox from '@/components/lnb/voucher/VoucherTotalBox'
import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import PopupVoucherGuide from '@/components/voucher/PopupVoucherGuide'
import BottomGuideIos from '@/components/lnb/voucher/BottomGuideIos'
import { voucherPurchase } from '@/common/util/common'
export default {
  name: 'VoucherPopupNew',
  components: {
    PopupAllProductCategoryNew,
    VoucherTotalBox,
    VoucherBanner,
    MyPooqEmptyList,
    PopupVoucherGuide,
    BottomGuideIos,
    BackButton,
    CloseButton
  },
  data () {
    return {
      dataList: [],
      type: utils.queryString.getQueryParamValue('type', 'use'),
      cpid: utils.queryString.getQueryParamValue('cpid'),
      channelid: utils.queryString.getQueryParamValue('channelid'),
      programid: utils.queryString.getQueryParamValue('programid'),
      contentid: utils.queryString.getQueryParamValue('contentid'),
      contenttype: utils.queryString.getQueryParamValue('contenttype'),
      device: utils.cookies.getDevice(),
      deviceType: utils.cookies.getItem('deviceType'), //ssfamilyhub 용 필드
      userLine: '0',
      disabledStyle: {
        opacity: 0.4
      },
      userLineToggle: false,
      toggleClass: 'option-open',
      purchaseGroupName: '',
      purchaseScreenName: '',
      purchaseQualityName: '',
      purchasePrice: 0,
      checkedProductType: '',
      dataListIndex: 0,
      isplayy: 'n',
      isLoading: false,
      currentProduct: {},
      currentProductName: '',
      currentDescription: '',
      currentPrice: '',
      concurrencyCount: 1,
      currentIndex: 'group_5_0_0',
      currentProductType: '',
      isEmptyList: false,
      productId: '',
      currentVoucherInfo: {}
    }
  },
  methods: {
    setNumberCommas (data) {
      if (!data) return 0
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getCurrentVoucher () {
      const indexInfo = this.currentIndex.split('_')
      const group = this.dataList[indexInfo[1]].productgroups[indexInfo[2]]
      return group.products[indexInfo[3]]
    },
    iosConverter (data) {
      this.dataList = data
    },
    converter (data) {
      let newProductsArr = []
      this.dataList = data.map((voucherData) => {
        if (voucherData.passgroup_type === 'voucher') {
          voucherData.productgroups.map((productgroups) => {
            if (productgroups.productgroup_name === 'wavve 팩') {
              productgroups.products.map((product) => {
                if (product.concurrency.length > 1) {
                  product.concurrency.map((voucher) => {
                    newProductsArr.push({
                      orderno: product.orderno,
                      screen_name: product.screen_name,
                      quality_name: product.quality_name,
                      concurrency_count: product.concurrency_count,
                      concurrency: [voucher]
                    })
                    productgroups.products = newProductsArr
                    return voucher
                  })
                } else {
                  newProductsArr.push(product)
                }
              })
            }
            return productgroups
          })
        }
        return voucherData
      })
    },
    purchase () {
      voucherPurchase({ deviceType: this.device, productId: this.productId, contentType: this.contenttype, contentId: this.contentid, action: 'routerBack' })
    },
    close () {
      this.$router.back()
    }
  },
  created () {
    window.utils = utils
    let voucherType = this.type === 'movie' ? 'all' : this.type
    let isPlayy = get(this.$route, ['query', 'playy'], 'n')
    let downloadyn = get(this.$route, ['query', 'downloadyn'], 'N')
    const isIOS = this.device === 'ios'
    if (this.isLoading) return
    this.isLoading = true
    if(this.$route.params != null) {
      this.cpid = this.$route.params.cpid
      this.channelid = this.$route.params.channelid
      this.programid = this.$route.params.programid
      this.contentid = this.$route.params.contentid
      this.contenttype = this.$route.params.contenttype
    }
    const params = {
      cpid: this.cpid,
      channelid: this.channelid,
      programid: this.programid,
      contentid: this.contentid,
      contenttype: this.contenttype,
      vouchertype: voucherType,
      isplayy: isPlayy,
      downloadyn: downloadyn
    }
    // INFO: IOS 일때 static json 호출
    const request = isIOS ? VoucherService.getPlayyOnlyVoucherList() : BottomTabService.purchaseProductsNew(params)
    request.then((response) => {
      let converter = this.device === 'ios' ? this.iosConverter : this.converter
      converter(response.data)
      const emptyList = this.dataList.filter((voucher) => voucher.productgroups_count === '0')
      this.isEmptyList = this.dataList.length === emptyList.length
      if (!this.isEmptyList) {
        this.dataList.some((voucher, index) => {
          this.currentProductType = voucher.passgroup_type
          if (voucher.passgroup_type === 'one' && voucher.productgroups.length > 0) {
            this.currentIndex = 'group_' + index + '_0_0'
            return true
          } else if (voucher.passgroup_type === 'package' && voucher.productgroups.length > 0) {
            this.currentIndex = 'group_' + index + '_0_0'
            return true
          } else if (voucher.passgroup_type === 'voucher' && voucher.productgroups.length > 0) {
            this.currentIndex = 'group_' + index + '_0_0'
            return true
          } else if (voucher.passgroup_type === 'wavve_option_ios' && voucher.productgroups.length > 0) {
            this.currentIndex = 'group_' + index + '_0_0'
          }
        })
        const indexInfo = this.currentIndex.split('_')
        this.currentVoucherInfo = get(this.dataList, [indexInfo[1], 'productgroups', indexInfo[2], 'products', '0'], {})
        this.productId = get(this.dataList, [indexInfo[1], 'productgroups', indexInfo[2], 'products', '0', 'concurrency', '0', 'productid'], '')
      }
      this.isLoading = false
    })
    EventBus.$on('popupSelectedVoucher', ({ list, selectedIndex, productType }) => {
      this.currentProductType = productType
      this.currentIndex = selectedIndex
      this.currentVoucherInfo = list
      this.productId = get(list, ['concurrency', '0', 'productid'], '')
    })
    EventBus.$on('changeSelectedIndex', this.onChangeSelectedIndex)
    EventBus.$on('productListInfo', this.onProductListInfo)
  },
  beforeDestroy () {
    EventBus.$off('changeSelectedIndex', this.onChangeSelectedIndex)
    EventBus.$off('productListInfo', this.onProductListInfo)
  }
}
</script>
<style lang="css" src="@/assets/new-css/base.css"></style>
<style lang="css" src="@/assets/new-css/voucher.css"></style>
<style scoped>
  .guide-wrapper{
    margin-bottom: 0;
  }
</style>
